import { useState, useCallback } from 'react';
import { SCROLL_TYPE } from '../../constants';

interface Params {
    slides: any[];
    slidesToShow: number;
    scrollType: SCROLL_TYPE;
    withSlidesIndicator: boolean;
    swipeMode: boolean;
    showSlidesIndicatorInSwipeMode: boolean;
}

const isSupporting = ({
    withSlidesIndicator,
    swipeMode,
    slidesToShow,
    scrollType,
    showSlidesIndicatorInSwipeMode
}: Omit<Params, 'slides'>) => {
    const basicSupport = withSlidesIndicator && (!swipeMode || showSlidesIndicatorInSwipeMode);
    const supportSingle = slidesToShow === 1 && scrollType === SCROLL_TYPE.SINGLE;
    return basicSupport && supportSingle;
};

export const useScrollCounter = ({
    slidesToShow,
    scrollType,
    withSlidesIndicator,
    swipeMode,
    showSlidesIndicatorInSwipeMode
}: Params) => {
    const [currentPosition, setCurrentPosition] = useState<number>(0);

    const supportSlidesIndicator = isSupporting({
        withSlidesIndicator, swipeMode, slidesToShow, scrollType, showSlidesIndicatorInSwipeMode });

    const changeCounterPosition = useCallback((newPosition: number) => setCurrentPosition(Math.max(newPosition, 0)), []);
    const resetCounterPosition = useCallback(() => setCurrentPosition(0), []);

    return {
        currentPosition,
        supportSlidesIndicator,
        changeCounterPosition,
        resetCounterPosition
    };
};
